import React, { PureComponent } from "react";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import "./callback.css";
import queryString from "query-string";
import {
  isEmpty,
  doLogout,
  getApiBaseURL,
  handleAPIErrors,
} from "../../common";
import Spinner from "@salesforce/design-system-react/components/spinner";
import { PU_RELEATIVE_PATH } from "../../../config";
import api from "../../../api";

class Callback extends PureComponent<{}, any> {
  constructor(props) {
    super(props);
    this.state = {};
  }
  async componentDidMount() {
    // return false;
    // document.getElementById('myAmy')
    try {
      this.getInitData();
    } catch (e) {
      console.log("some error", e, e.message);
    }
  }

  //Using Auth Code authenticate the connected app to get access token.
  getSalesForceOrgAccessTokenAndSave(authCode, isSandbox) {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      // body: JSON.stringify(authCode),
    };

    if (isSandbox)
      requestOptions.headers = {
        "Content-Type": "application/json",
        OrgType: "sandbox",
      };

    api.post(getApiBaseURL() + "/Login", JSON.stringify(authCode), requestOptions)
      // .then(handleAPIErrors)
      .then((response) => response.data)
      .then((response) => {
        localStorage.setItem("isSandbox", isSandbox);
        localStorage.setItem("access_token", response.token);
        localStorage.setItem("refresh_token", response.refreshToken);
        localStorage.setItem("user_type", response.userType);
        localStorage.setItem("org_id", response.orgId);
        this.redirectToRegistrationPageWithOrgId();
      });
  }

  //Redirect to registration form page by passing the Organization ID.
  redirectToRegistrationPageWithOrgId() {
    window.location.href = PU_RELEATIVE_PATH + "consent-form";
  }

  getInitData = async () => {
    let checkParams = queryString.parse(this.props.location.search);
    let type = this.props.match.params.type;
    let authcode = checkParams?.code;
    let state = checkParams?.state;
    let loginToSandBox = false;

    // Get error msg from Salesforce CallBack URL
    this.error = checkParams?.error;
    this.error_description = checkParams.error_description;
    // If it is present then alert and clear  access token
    if (!isEmpty(this.error)) {
      doLogout();
      window.location.href =
        window.location.origin +
        "/registration/ui/forbidden?error=" +
        this.error +
        "&error_description=" +
        this.error_description;
    }

    // Check if the login Type is not empty and set the sandbox login flag.
    if (!isEmpty(type) && type.toLowerCase() === "sandbox") {
      loginToSandBox = true;
    }

    if (!isEmpty(authcode)) {
      if (state === sessionStorage.getItem("state")) {
        //this.authservice.getSalesForceOrgAccessTokenAndSave(this.authCode, this.loginToSandBox);
        sessionStorage.removeItem("state");
        this.getSalesForceOrgAccessTokenAndSave(authcode, loginToSandBox);
      } else {
        console.log("Invalid State");
        doLogout();
        window.location.href = PU_RELEATIVE_PATH + "welcome";
      }
    }
  };

  render() {
    return (
      <div class="callback-background-theme">
        <Spinner
          size="large"
          variant="brand"
          assistiveText={{ label: "Loading..." }}
        />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Callback));
